import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup } from '@angular/forms';
import { UserService } from '../../../shared/user.service';
import { Office } from '../../../shared/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-office-form',
  templateUrl: './office-form.component.html',
  styleUrls: ['./office-form.component.css']
})
export class OfficeFormComponent implements OnInit {
  
  c: any={};
  arealist: any=[];
  taluklist: any=[];
  districtlist: any=[];
  statelist: any=[];
  areabasedlist: any=[];
  data: any={};

  office:any ={};
  formSubmitted: boolean;
  OfficeId:string;
  mode:string;

  DistrictList;
officelevellist;
title="Add Branch";
  service: any;
  stcoundata: any;
  c_code: any;
  st_code: any;
  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute,private errorHandler:ErrorHandler) {
    this.OfficeId=null;
    this.mode=null;
    this.office=new Office();
    this.formSubmitted = false;
    // this.GetAllAreas();
    // this.GetAllTaluks();
    // this.GetAllDistricts();
    // this.GetAllStates();
   
   
   }

  ngOnInit() {
  this.GetAllDistrictNames();
  this.GetAllOfficelevels();
  this.GetAllAreas();
    this.route.params.subscribe(params =>

      this.OfficeId = params['OfficeId']
      
    );
    
 

    this.route.params.subscribe(params =>
      this.mode = params['mode']
      
    );
    if (this.OfficeId != null && this.mode!=null) 
      this.GetOfficeForTheId(this.OfficeId);
    
      this.GetAllTaluks();
    this.GetAllDistricts();
    this.GetAllStates();
  }


  GetAllDistrictNames() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictNames();
    this.data.subscribe(
      (response) => {
        this.DistrictList = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetAllOfficelevels() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllOfficelevels();
    this.data.subscribe(
      (response) => {
        this.officelevellist = response;
        document.getElementById('loader-spinner').style.display = "none";
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }
  GetAllAreas() {
    debugger;
      this.data = this.userService.getAllAreas1();
      this.data.subscribe(
        (response:any) => {
          this.arealist = response;
          console.log(this.arealist);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

  GetAllAreasview(aid:any) {
    debugger;
    let acode;
      this.data = this.userService.getAllAreas1();
      this.data.subscribe(
        (response:any) => {
          for(let i=0;i<response.length;i++){
            if(aid==response[i].BRANCH_ID){
              this.office.ANAME=response[i].ACODE;
              this.office.PMANAME= response[i].ACODE;  //response;
              this.office.OANAME=response[i].ACODE;
           }
          }
          return acode;
        
        });
  }
  GetAllTaluks() {
    debugger;
      this.data = this.userService.getAllTaluks1();
      this.data.subscribe(
        (response:any) => {
          this.taluklist = response;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  GetAllDistricts() {
    debugger;
      this.data = this.userService.getAllDistricts1();
      this.data.subscribe(
        (response:any) => {
          this.districtlist = response;
          console.log(this.districtlist);
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  GetAllStates() {
    debugger;
      this.data = this.userService.getAllStates1();
      this.data.subscribe(
        (response:any) => {
          this.statelist = response;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }

  
  GetAllDetailsBasedOnArea(ANAME){
    debugger;
      this.data = this.userService.getAllDetailsBasedOnArea1(ANAME);
      this.data.subscribe(
        (response:any) => {
          this.areabasedlist = response;
          console.log(this.areabasedlist);
          this.office.ST_CODE=this.areabasedlist[0].ST_NAME;
          this.office.DIS_CODE =this.areabasedlist[0].DIS_NAME;
          this.office.PINCODE =this.areabasedlist[0].PINCODE;
          this.office.SUB_DIS_CODE =this.areabasedlist[0].SUB_DIS_NAME;
        }, (error) => {
          this.errorHandler.handleError(error);
        });
  }


  GetOfficeForTheId(OfficeId) {
   
    let offdata;
    let companyid=localStorage.getItem('Cmp_Id');
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getOfficeForTheId(OfficeId)
      .subscribe(
        (data) => {

          offdata=data;
          this.office = data;
          console.log(this.office);
          debugger;
         
          //this.office.Off_Level=offdata.Off_Level;
          this.office.DIS_CODE=offdata.Off_District_Id_Fk;
          this.office.DIS_ADD=offdata.Off_Address1;
          this.office.DIS_ADD_LL=offdata.Off_Address2;
          this.office.ANAME=offdata.Off_District_Id_Fk;
          this.Getstatecountry(offdata.Off_District_Id_Fk)
          this.office.PINCODE=offdata.Off_pincode;
          this.office.PHONE=offdata.Off_Landline;
          this.office.MOBILE=offdata.Off_PhoneNumber;
          this.office.EMAIL=offdata.Off_Email;

          for(let i=0;i<this.officelevellist.length;i++)
          {

            if(offdata.Off_Level==this.officelevellist[i].OL_Id)
            {
              debugger;
              this.office.Off_Level=this.officelevellist[i].OL_Id
            }
          }

          //this.isUpdate=true;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  update(form: NgForm) {
    if (!form.invalid) {
      form.value.comp_id=localStorage.getItem('Cmp_Id');
      form.value.DI_District=form.value.DIS_CODE;
      form.value.Off_Address1=form.value.DIS_ADD;
      form.value.Off_Address2=form.value.DIS_ADD_LL;
      form.value.Off_District_Id_Fk =form.value.DIS_CODE;
      form.value.Off_pincode=form.value.PINCODE;
      form.value.Off_PhoneNumber=form.value.MOBILE;
      form.value.Off_Email=form.value.EMAIL;
      form.value.Off_Landline=form.value.PHONE;
    document.getElementById('loader-spinner').style.display = "block";
    debugger;
    console.log(form.value);
    this.userService.updateOffice(form.value,this.OfficeId)
      .subscribe(
        (data) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Updated Successfully!','success');
          this.router.navigate(['/home/office']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
          //swal('Warning!', error.error.Message, 'warning');
        });
      }else
        document.getElementById('loader-spinner').style.display = "none";
        this.formSubmitted = true;
  }

    onSubmit(form: NgForm) {
      debugger;
      if(this.office.OfficeName==undefined||null || this.office.Off_Level==undefined||null || this.office.DIS_ADD==undefined||null ||
          this.office.DIS_CODE==undefined||null ||  this.office.PINCODE==undefined||null || this.office.MOBILE==undefined||null ||
          this.office.PHONE==undefined||null || this.office.EMAIL==undefined||null
        )
        {
          swal('Empty Fields','Please fill all the mandatory fields','warning');
        }
      else if (!form.invalid) {
        form.value.comp_id=localStorage.getItem('Cmp_Id');
        form.value.DI_District=form.value.DIS_CODE;
        form.value.Off_Address1=form.value.DIS_ADD;
        form.value.Off_Address2=form.value.DIS_ADD_LL;
        form.value.Off_District_Id_Fk =form.value.DIS_CODE;
        form.value.Off_pincode=form.value.PINCODE;
        form.value.Off_PhoneNumber=form.value.MOBILE;
        form.value.Off_Email=form.value.EMAIL;
        form.value.Off_Landline=form.value.PHONE;
        
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.CreateOffice(form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            swal('','Saved Successfully!','success');
            this.router.navigate(['/home/office']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            //this.errorHandler.HandlerError(error);
            swal('Warning!', error.error.Message, 'warning');
          });
        }else{
        document.getElementById('loader-spinner').style.display = "none";
        this.formSubmitted = true;
        }
    }


  //   onSubmit(customer_creation: NgForm) {
  //     debugger;
  //   if
  //   (  customer_creation.value.HouseNo1==undefined||null &&  
  //     customer_creation.value.ANAME==undefined &&  customer_creation.value.MOBILE==undefined && customer_creation.value.EMAIL==undefined 
      
  //     )
  //   {
  //     swal("Warning!", "Please enter all the Mandatory fields",'warning');
  //   }
  
  //   else
  //   {
  
  //   // if (NgForm==VALID) 
  //   //  {
        
  //       if(customer_creation.value.PHONE==null||undefined)
  //          customer_creation.value.PHONE=0;
        
  
  //          debugger;
  
  //   }
  
  //   //For Taluk code
  //   for (let i = 0; i < this.taluklist.length; i++) {
  //     if (this.taluklist[i].SUB_DIS_NAME == this.office.SUB_DIS_CODE) {
  //       let talukcode = this.taluklist[i].SUB_DIS_CODE;
  //       customer_creation.value.SUB_DIS_CODE=talukcode;
  //     }
  //   }

  //    //For Districtcode
  //    for (let i = 0; i < this.districtlist.length; i++) {
  //     if (this.districtlist[i].DIS_NAME == this.office.DIS_CODE) {
  //       let districtcode = this.taluklist[i].SUB_DIS_CODE;
  //       customer_creation.value.DIS_CODE=districtcode;
  //     }
  //   }

  //    //For Statecode
  //    for (let i = 0; i < this.statelist.length; i++) {
  //     if (this.statelist[i].ST_NAME == this.office.ST_CODE) {
  //       let statecode = this.statelist[i].ST_CODE;
  //       customer_creation.value.ST_CODE=statecode;
  //     }
  //   }
    

    
  // }

  Getstatecountry(dis_code)
  {
    debugger;
    this.stcoundata=this.userService.getstatecountry(dis_code);
    this.stcoundata.subscribe(
      (response:any)=>
      {
        debugger;

        this.office.ST_CODE=response.ST_NAME;
        this.st_code=response.ST_CODE;
        this.office.C_NAME=response.C_NAME;
        this.c_code=response.C_CODE;

      }
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/ultilities/office/office-form/office-form.component.ts